import MatchOddsMarketScopeModel from "./MatchOddsMarketScopeModel";
import MatchOddsMarketSelectionModel from "./MatchOddsMarketSelectionModel";
import MatchOddsMarketTypeModel from "./MatchOddsMarketTypeModel";

export default class MatchOddsMarketModel {
  public type: MatchOddsMarketTypeModel | null = null;
  public scope: MatchOddsMarketScopeModel | null = null;
  public selections: MatchOddsMarketSelectionModel[] = [];
}
